import type { FC } from 'react';
import { Anchor, AnchorProps, PageAnchorWrapper } from './styled';

export interface Props extends AnchorProps {
  id: string;
}

const defaultProps: Partial<Props> = {
  type: 'section-title',
};

const PageAnchor: FC<Props> = ({ id, type }) => {
  return (
    <PageAnchorWrapper>
      <Anchor id={id} type={type} />
    </PageAnchorWrapper>
  );
};

PageAnchor.defaultProps = defaultProps;

export default PageAnchor;
